import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { maintenanceLogSettingsInitialState, ColumnSettings } from './maintenance-log-settings-initial-state';

const maintenanceLogSettingsSlice = createSlice({
  name: 'maintenanceLogSettings',
  initialState: maintenanceLogSettingsInitialState,
  reducers: {
    setColumnVisibility: (state, action: PayloadAction<{ key: string; visible: boolean }>) => {
      const column = state.columnSettings.find(c => c.key === action.payload.key);
      if (column) {
        column.visible = action.payload.visible;
      }
    },
    setColumnOrder: (state, action: PayloadAction<ColumnSettings[]>) => {
      state.columnSettings = action.payload;
    },
    resetColumnSettings: (state) => {
      state.columnSettings = maintenanceLogSettingsInitialState.columnSettings;
    },
  },
});

export const {
  setColumnVisibility,
  setColumnOrder,
  resetColumnSettings,
} = maintenanceLogSettingsSlice.actions;

export default maintenanceLogSettingsSlice.reducer;
